// Display formatting shared across pages. Each of these used to exist in three to five
// hand-written copies, several of which could print an impossible "0:60".

/** `m:ss`, or `m:ss.s` when ``precise`` — a timestamp in a video. Rounds the whole value
 *  first, so 59.96s reads 1:00.0 rather than 0:60.0. */
export function formatClock(seconds: number, precise = false): string {
  const step = precise ? 10 : 1;
  const total = Math.round(Math.max(0, seconds) * step) / step;
  const minutes = Math.floor(total / 60);
  const rest = total - minutes * 60;
  const secondsText = precise ? rest.toFixed(1).padStart(4, "0") : String(Math.round(rest)).padStart(2, "0");
  return `${minutes}:${secondsText}`;
}

/** How long something took: `4.2s` under a minute, `3m 12s` above it. */
export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const whole = Math.round(seconds);
  return `${Math.floor(whole / 60)}m ${whole % 60}s`;
}

/** Dollars. Sub-cent amounts (a single LLM call) keep three decimals, because at two they
 *  would all read "$0.00" and the point is usually comparing them. */
export function formatUsd(value: number): string {
  return value < 0.01 && value > 0 ? `$${value.toFixed(3)}` : `$${value.toFixed(2)}`;
}

export function pluralize(count: number, word: string, plural = `${word}s`): string {
  return `${count} ${count === 1 ? word : plural}`;
}
